export default __webpack_public_path__ + "static/media/2017 LV BOOTH LAST BOARD-01.a27a3e61.jpg";